/**
 * Domínio: UI global do app (navegação, topbar).
 *
 * Slots fora da área de atendimento — menu lateral e barra superior.
 * Acesse via `app.slots.SIDEBAR_MENU`.
 */
export const app = {
  slots: {
    /** Item no menu lateral de navegação (vira página própria do plugin). */
    SIDEBAR_MENU: "sidebar-menu",
    /**
     * Barra superior (navbar). Itens de plugin sem ponto específico caem aqui
     * (renderizados ao final). Cada item nativo tem também seu próprio slot
     * (NAVBAR_*) — o componente nativo é envolto num PluginBridge daquele slot,
     * então plugins podem estender/interceptar cada ponto individualmente.
     */
    NAVBAR: "navbar",
    /** Slot do indicador de status do WebSocket. */
    NAVBAR_SOCKET_STATUS: "navbar:socket-status",
    /** Slot do seletor de idioma. */
    NAVBAR_LANGUAGE: "navbar:language",
    /** Slot do alternador de tema (claro/escuro). */
    NAVBAR_THEME: "navbar:theme",
    /** Slot do controle de volume das notificações. */
    NAVBAR_VOLUME: "navbar:volume",
    /** Slot do botão de recarregar a página. */
    NAVBAR_REFRESH: "navbar:refresh",
    /** Slot do sino de notificações. */
    NAVBAR_NOTIFICATIONS: "navbar:notifications",
    /** Slot do popover de anúncios. */
    NAVBAR_ANNOUNCEMENTS: "navbar:announcements",
    /** Slot do popover de chat interno. */
    NAVBAR_CHAT: "navbar:chat",
  },
} as const;
